module.exports = __webpack_public_path__ + "img/12.0c96c759.jpg";